import { render, staticRenderFns } from "./ModelLog.vue?vue&type=template&id=8cd04646"
import script from "./ModelLog.vue?vue&type=script&lang=js"
export * from "./ModelLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports